
.modal {
  width: min(70rem, 70vw);
}

.header {
  padding: 0 2rem;
}

.body {
  padding: 0;
}

.nowrap {
  white-space: nowrap;
}

.fnskuBody {
  padding: 0.75rem 1rem;
}

.settingsBody {
  padding: 1rem;
}

.customFNSKULabelColumns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.customFNSKULabelInputColumns {
  display: grid;
  grid-template-columns: 3fr 5fr;
  gap: 0.5rem;
}

.fnskuRowTitle {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(min(60rem, 60vw)/2);
  white-space: nowrap;
}

.fnskuRow:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
}

.otherLabelsBody {
  padding: 1rem;
}

.emptyFnskuState {
  padding: 1rem;
}


